"use strict";

import { addEvent } from "./addEvent/addEvent";
import { preloadingEnd } from './loading/loading';

addEvent(window, 'load', function () {
  setTimeout(() => preloadingEnd(), 1500);
});
